import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-enterprise';
import { format, isValid, parseISO } from 'date-fns';

export class GridRow {
  headerName: string;
  fieldName: string;
  fieldData: any;
}

@Injectable()
export class AgGridPrintService {
  private createPrintWindow(title: string): Window {
    const printWindow = window.open();
    printWindow.document.write(`<html><head><title>${title}</title>`);
    printWindow.document.write(
      `<link rel='stylesheet' href='/assets/print.css'/>`
    );
    printWindow.document.write('</head><body>');
    return printWindow;
  }

  printGrid(
    title: string,
    columnDefs: any,
    rowData: any[],
    styles: string
  ): void {
    const printWindow = this.createPrintWindow(title);
    const table = this.generateTable(columnDefs, rowData);
    const style = styles ? styles : this.setStyles();
    printWindow.document.write(style);
    printWindow.document.write(table);
    printWindow.document.write('</body></html>');
    printWindow.document.close(); // necessary for IE >= 10
    printWindow.onload = () => {
      printWindow.focus(); // necessary for IE >= 10
      printWindow.print();
      printWindow.close();
    };
  }

  private generateTable(columnDefs: ColDef[], rowData: any[]): string {
    let table = '<table><tr>';
    for (const def of columnDefs) {
      table += '<th>' + def.headerName + '</th>';
    }
    table += '</tr>';
    for (const data of rowData) {
      table += '<tr>';
      for (const def of columnDefs) {
        if (typeof data[def.field] === 'object' && data[def.field] !== null) {
          table += '<td>' + this.getDescriptiveField(data[def.field]) + '</td>';
        } else if (
          typeof data[def.field] === 'boolean' &&
          data[def.field] !== null
        ) {
          data[def.field]
            ? (table += '<td>Yes</td>')
            : (table += '<td>No</td>');
        } else if (data[def.field] !== null) {
          table += '<td>' + this.formatIfDate(data[def.field]) + '</td>';
        } else {
          table += '<td></td>';
        }
      }
      table += '</tr>';
    }
    table += '</table>';
    return table;
  }

  private getDescriptiveField(rowData: any): string {
    if (rowData.name) {
      return rowData.name;
    } else if (rowData.description) {
      return rowData.description;
    }
  }

  private formatIfDate(rowData: any): string {
    if (isValid(parseISO(rowData))) {
      return format(parseISO(rowData), 'dd-MM-yyyy');
    }
    return rowData;
  }

  private setStyles(): string {
    return `<head><style>
    table {
      font-family: arial, sans-serif;
      border-collapse: collapse;width: 100%;
      font-size: 13px
    }
    td, th {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 8px;
    }
    </style></head>`;
  }
}
